import React from 'react';
import { Spinner } from 'react-bootstrap';
import {
  FileEarmarkText,
  FileEarmarkPdf,
  FileEarmarkImage,
  XLg,
  ExclamationTriangleFill,
} from 'react-bootstrap-icons';
import { ContextSource } from '../../types/context.types';
import { formatFileSize } from '../../utils/fileUtils';
import './SourceItem.css';

interface SourceItemProps {
  source: ContextSource;
  onDelete: (source: ContextSource) => void;
}

const getFileIcon = (fileType: string) => {
  if (fileType === 'application/pdf') return <FileEarmarkPdf size={14} />;
  if (fileType.startsWith('image/')) return <FileEarmarkImage size={14} />;
  return <FileEarmarkText size={14} />;
};

const SourceItem: React.FC<SourceItemProps> = ({ source, onDelete }) => {
  const isProcessing = source.status === 'uploading' || source.status === 'processing';
  const isFailed = source.status === 'failed';

  return (
    <div className="source-item" data-source-id={source.id} title={source.fileName}>
      <span className="source-icon">{getFileIcon(source.fileType)}</span>
      <span className="source-filename">{source.fileName}</span>
      {isProcessing && <Spinner animation="border" size="sm" className="source-spinner" />}
      {isFailed && (
        <ExclamationTriangleFill
          size={12}
          className="source-failed-icon"
          title={source.errorMessage || 'Processing failed'}
        />
      )}
      <span className="source-size">{formatFileSize(source.fileSize)}</span>
      <button
        className="source-delete-btn"
        onClick={(e) => {
          e.stopPropagation();
          onDelete(source);
        }}
        title="Delete source file"
        aria-label={`Delete ${source.fileName}`}
      >
        <XLg size={10} />
      </button>
    </div>
  );
};

export default SourceItem;
